/**
 * Created by Languagenut on 23/05/2019.
 */


import React  from 'react';
import Report from './grade_book.js';
import ReportService from '../../services/reports-service.js';
import DetailedTable from './details/sentence.js'
export default class SentenceReport extends Report {

    constructor(props) {
        super();
    }

    getResults(isRoot , screenUID , crumbTranslation){



        this.history = this.history.slice(0, this.findHistoryIndex(screenUID));

        if(isRoot)
        {
            this.history = [];
        }

        this.history.push({name:crumbTranslation , screenID:screenUID});

        this.setState({loaded:false});


        ReportService.getSentence(screenUID , this.props.language , this.state.startDate.unix() , this.state.endDate.unix() , this.props.classID , this.props.studentID).then(function(response){

            var modules = response.modules.map(function(module){
                module.catalogUid = true;
                return module;
            });
            this.selectionIndex = 0;
            this.setState({
                isDetail:false,
                primary:response.data,
                modules:modules,
                loaded:true,
                ranges:this.processRanges(response.data),
            })
        }.bind(this));
    }

    getTableDetail(){
        return <DetailedTable onDownload={this.onDownloaded.bind(this)} triggerDownload={this.state.triggerDownload} set={this.state.startDate.unix()} due={this.state.endDate.unix()}  language={this.props.language}  studentID={this.props.studentID} classID={this.props.classID} onClick={this.setDetailed.bind(this , null)} module={this.state.module} />
    }

}